exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.badge[data-v-1d7a862e] {\r\n  position: relative;\r\n  min-width: 85px;\r\n  min-height: 34px;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n  border-radius: 20px;\r\n  background-color: #ccc;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  font-size: 14px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-1d7a862e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/badge.vue
// module id = 574
// module chunks = 0